import { apiClient } from '@/lib/api/client';
export const groupsApi = {
    async getGroups(query) {
        const { data } = await apiClient.get('/api/v1/groups', { params: query });
        return data;
    },
    async getGroup(id) {
        const { data } = await apiClient.get(`/api/v1/groups/${id}`);
        return data;
    },
    async createGroup(dto) {
        const { data } = await apiClient.post('/api/v1/groups', dto);
        return data;
    },
    async updateGroup(id, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${id}`, dto);
        return data;
    },
    async updateStatus(id, status) {
        const { data } = await apiClient.patch(`/api/v1/groups/${id}/status`, { status });
        return data;
    },
    async deleteGroup(id) {
        await apiClient.delete(`/api/v1/groups/${id}`);
    },
    async assignGuide(groupId, userId) {
        await apiClient.post(`/api/v1/groups/${groupId}/guides`, { userId });
    },
    async removeGuide(groupId, userId) {
        await apiClient.delete(`/api/v1/groups/${groupId}/guides`, { data: { userId } });
    },
    async listGuides(groupId) {
        const { data } = await apiClient.get(`/api/v1/groups/${groupId}/guides`);
        return data;
    },
};
//# sourceMappingURL=groups.js.map